<template>
  <div class="app-content pt-3 p-md-3 p-lg-4">
    <div class="container-xl">
      <h1 class="app-page-title">Appointments</h1>
      <hr class="mb-4" />
      <div class="row g-4 settings-section">
        <div class="col-12 col-md-12">
          <div class="app-card app-card-settings shadow-sm p-4">
            <div class="app-card-body">
              <div v-if="isLoading" class="text-center">Please Waiting...</div>
              <div>
                <input type="text" class="form-control mb-3" placeholder="Enter patient name / mobile number" v-model="searchBy" @input="getAppointments">
              </div>
              <table class="table table-bordered" v-if="!isLoading">
                  <thead class="text-center">
                      <tr>
                        <th>SL</th>
                        <th>Entry date</th>
                        <th>Appointment Date</th>
                        <th>Patient name</th>
                        <th>Mobile Number</th>
                        <th>Gender</th>
                        <th>Prescription Date</th>
                        <th>Image</th>
                        <th>Action</th>
                      </tr>
                  </thead>
                  <tbody class="text-center">
                      <tr v-for="(appointment,ind) in appointments" :key="ind">
                        <td>{{ ind+1 }}</td>
                        <td>{{ appointment.custom_today_date }}</td>
                        <td>{{ appointment.custom_appointment_date }} {{ appointment.time }}</td>
                        <td>{{ appointment.patient_name }}</td>
                        <td>{{ appointment.mobile_number }}</td>
                        <td>{{ appointment.gender }}</td>
                        <td v-if="appointment.prescriptions.length > 0">{{ appointment.prescriptions[0].prescription_written_date }}</td>
                        <td v-else>-</td>
                        <td><img style="height:50px;" :src="'https://user.besthomeodoctor.com/'+appointment.image" alt=""></td>
                        <td>
                            <router-link :to="{ name: 'PrintPrescription', params: { id: appointment.id } }" class="mr-1" target="_blank">
                              <svg id="Capa_1" enable-background="new 0 0 512 512" height="20" viewBox="0 0 512 512" width="20" xmlns="http://www.w3.org/2000/svg"><g><path d="m437 129h-14v-54c0-41.355-33.645-75-75-75h-184c-41.355 0-75 33.645-75 75v54h-14c-41.355 0-75 33.645-75 75v120c0 41.355 33.645 75 75 75h14v68c0 24.813 20.187 45 45 45h244c24.813 0 45-20.187 45-45v-68h14c41.355 0 75-33.645 75-75v-120c0-41.355-33.645-75-75-75zm-318-54c0-24.813 20.187-45 45-45h184c24.813 0 45 20.187 45 45v54h-274zm274 392c0 8.271-6.729 15-15 15h-244c-8.271 0-15-6.729-15-15v-148h274zm89-143c0 24.813-20.187 45-45 45h-14v-50h9c8.284 0 15-6.716 15-15s-6.716-15-15-15h-352c-8.284 0-15 6.716-15 15s6.716 15 15 15h9v50h-14c-24.813 0-45-20.187-45-45v-120c0-24.813 20.187-45 45-45h362c24.813 0 45 20.187 45 45z"/><path d="m296 353h-80c-8.284 0-15 6.716-15 15s6.716 15 15 15h80c8.284 0 15-6.716 15-15s-6.716-15-15-15z"/><path d="m296 417h-80c-8.284 0-15 6.716-15 15s6.716 15 15 15h80c8.284 0 15-6.716 15-15s-6.716-15-15-15z"/><path d="m128 193h-48c-8.284 0-15 6.716-15 15s6.716 15 15 15h48c8.284 0 15-6.716 15-15s-6.716-15-15-15z"/></g></svg>
                            </router-link>

                            <router-link :to="{ name: 'SingleAppointment', params: { id: appointment.id } }" class="mr-1">
                              <svg id="Capa_1" enable-background="new 0 0 512 512" height="20" viewBox="0 0 512 512" width="20" xmlns="http://www.w3.org/2000/svg"><g><g><path d="m106.907 104.334v367.033c0 18.299 14.834 33.133 33.133 33.133h314.769c18.299 0 33.133-14.834 33.133-33.133v-367.033z" fill="#f9f5f3"/><path d="m464.941 104.334v367.033c0 18.299-14.834 33.133-33.133 33.133h23c18.299 0 33.133-14.834 33.133-33.133v-367.033z" fill="#f9eae0"/><g><path d="m225.409 393.911-129.302-129.302-46.858 46.858 129.302 129.302c1.5 1.5 3.535 2.343 5.657 2.343h7.141l36.403-36.403v-7.142c0-2.12-.843-4.155-2.343-5.656z" fill="#a0c8ff"/><path d="m225.409 393.911-129.302-129.302-11.477 11.477 133.806 133.806c1.097 1.097 1.838 2.481 2.159 3.974l7.156-7.156v-7.142c.001-2.121-.842-4.156-2.342-5.657z" fill="#91b2fa"/><path d="m227.752 435.112v-35.544c0-.966-.183-1.911-.515-2.799l-45.828 45.828c.888.332 1.833.515 2.799.515h35.544c4.418 0 8-3.581 8-8z" fill="#f9eae0"/><path d="m52.329 244.26-23.429 23.429c-6.47 6.47-6.47 16.959 0 23.429l23.429 23.429 46.858-46.858-23.429-23.429c-6.47-6.469-16.959-6.469-23.429 0z" fill="#fa8ebb"/><path d="m52.567 244.045c.078.075.162.139.238.215l34.905 34.905 11.476-11.476-23.428-23.429c-6.393-6.393-16.705-6.457-23.191-.215z" fill="#f57fb0"/></g><path d="m454.808 40.634h-314.769c-18.299 0-33.133 14.834-33.133 33.133v49.701h381.034v-49.702c.001-18.298-14.833-33.132-33.132-33.132z" fill="#ffce69"/><path d="m454.808 40.634h-23c18.299 0 33.133 14.834 33.133 33.133v49.701h23v-49.702c0-18.298-14.834-33.132-33.133-33.132z" fill="#ffbd61"/><g fill="#bdd3dd"><path d="m156.607 57.2c0 9.15 7.417 16.567 16.567 16.567s16.567-7.417 16.567-16.567v-33.133c0-9.15-7.417-16.567-16.567-16.567s-16.567 7.417-16.567 16.567z"/><path d="m405.107 57.2c0 9.15 7.417 16.567 16.567 16.567s16.567-7.417 16.567-16.567v-33.133c0-9.15-7.417-16.567-16.567-16.567s-16.567 7.417-16.567 16.567z"/><path d="m239.44 57.2c0 9.15 7.417 16.567 16.567 16.567s16.567-7.417 16.567-16.567v-33.133c0-9.15-7.417-16.567-16.567-16.567s-16.567 7.417-16.567 16.567z"/><path d="m322.274 57.2c0 9.15 7.417 16.567 16.567 16.567s16.567-7.417 16.567-16.567v-33.133c0-9.15-7.417-16.567-16.567-16.567s-16.567 7.417-16.567 16.567z"/></g><path d="m421.674 7.5c-4.47 0-8.52 1.779-11.5 4.657 3.119 3.013 5.067 7.23 5.067 11.91v33.133c0 4.679-1.948 8.897-5.067 11.91 2.98 2.878 7.03 4.657 11.5 4.657 9.15 0 16.567-7.417 16.567-16.567v-33.133c0-9.15-7.417-16.567-16.567-16.567z" fill="#abc4d6"/><path d="m338.841 7.5c-4.471 0-8.52 1.779-11.5 4.657 3.119 3.013 5.067 7.23 5.067 11.91v33.133c0 4.679-1.948 8.897-5.067 11.91 2.98 2.878 7.029 4.657 11.5 4.657 9.15 0 16.567-7.417 16.567-16.567v-33.133c0-9.15-7.417-16.567-16.567-16.567z" fill="#abc4d6"/><path d="m256.008 7.5c-4.47 0-8.52 1.779-11.5 4.657 3.119 3.013 5.067 7.23 5.067 11.91v33.133c0 4.679-1.947 8.897-5.067 11.91 2.98 2.878 7.03 4.657 11.5 4.657 9.15 0 16.567-7.417 16.567-16.567v-33.133c0-9.15-7.418-16.567-16.567-16.567z" fill="#abc4d6"/><path d="m173.174 7.5c-4.471 0-8.52 1.779-11.5 4.657 3.119 3.013 5.067 7.23 5.067 11.91v33.133c0 4.679-1.947 8.897-5.067 11.91 2.98 2.878 7.029 4.657 11.5 4.657 9.15 0 16.567-7.417 16.567-16.567v-33.133c0-9.15-7.417-16.567-16.567-16.567z" fill="#abc4d6"/></g><g><path d="m454.808 33.134h-9.067v-9.067c0-13.271-10.796-24.067-24.067-24.067s-24.067 10.796-24.067 24.067v9.067h-34.7v-9.067c.001-13.271-10.796-24.067-24.066-24.067s-24.067 10.796-24.067 24.067v9.067h-34.7v-9.067c0-13.271-10.796-24.067-24.067-24.067s-24.067 10.796-24.067 24.067v9.067h-34.7v-9.067c.001-13.271-10.796-24.067-24.066-24.067-13.271 0-24.067 10.796-24.067 24.067v9.067h-9.068c-22.405 0-40.632 18.228-40.632 40.632v183.537l-18.346-18.346c-9.384-9.384-24.651-9.384-34.035 0l-23.429 23.429c-9.384 9.383-9.384 24.652 0 34.035l75.81 75.81v99.136c0 22.405 18.228 40.633 40.632 40.633h255.135c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-255.135c-14.134 0-25.632-11.499-25.632-25.633v-84.136l61.184 61.184c.178.178.364.346.557.503.131.107.267.202.403.299.064.045.124.096.189.139.172.115.349.217.528.316.034.019.066.041.1.059.189.101.382.189.576.272.029.012.056.028.086.04.189.078.381.144.574.206.04.013.078.029.118.041.182.055.366.098.55.138.055.012.108.029.163.04.179.035.359.058.54.08.063.008.124.021.187.027.243.024.488.036.732.036h43.751l9.518 9.518c1.464 1.464 3.384 2.197 5.303 2.197s3.839-.733 5.303-2.197c2.929-2.929 2.929-7.678 0-10.607l-9.518-9.517v-43.749c0-.246-.012-.491-.036-.736-.005-.054-.017-.106-.023-.16-.023-.19-.048-.379-.085-.567-.01-.048-.024-.095-.035-.143-.042-.191-.087-.382-.143-.57-.01-.034-.024-.066-.035-.1-.063-.199-.132-.397-.212-.592-.009-.021-.02-.041-.029-.062-.086-.203-.179-.404-.283-.6-.014-.026-.03-.049-.044-.075-.103-.188-.211-.373-.331-.553-.037-.056-.081-.108-.12-.163-.102-.145-.204-.29-.317-.429-.158-.193-.325-.379-.503-.557l-61.185-61.185h258.087c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-265.067c-2.203 0-4.179.956-5.551 2.469l-44.933-44.932v-141.334h366.034v51.151c0 4.142 3.358 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-108.352c.001-22.405-18.227-40.632-40.632-40.632zm-234.556 402.478h-21.251l21.251-21.251zm-157.317-121.065 12.822-12.822 117.959 117.959-12.822 12.822zm141.388 94.53-117.959-117.959 12.823-12.823 117.959 117.959zm-170.12-136.084 23.429-23.429c3.535-3.535 9.287-3.535 12.822 0l18.126 18.126-18.123 18.123c-.001.001-.002.002-.002.002-.001.001-.002.002-.002.002l-18.124 18.123-18.125-18.125c-3.536-3.535-3.536-9.287-.001-12.822zm387.471-257.993c5 0 9.067 4.067 9.067 9.067v33.133c0 5-4.067 9.067-9.067 9.067s-9.067-4.067-9.067-9.067v-16.556c0-.003 0-.006 0-.01s0-.006 0-.01v-16.557c.001-5 4.068-9.067 9.067-9.067zm-82.833 0c5 0 9.067 4.067 9.067 9.067v33.133c0 5-4.067 9.067-9.067 9.067s-9.067-4.067-9.067-9.067v-16.556c0-.003 0-.006 0-.01s0-.006 0-.01v-16.557c0-5 4.067-9.067 9.067-9.067zm-91.9 9.067c0-5 4.067-9.067 9.067-9.067s9.067 4.067 9.067 9.067v16.557.01s0 .006 0 .01v16.556c0 5-4.067 9.067-9.067 9.067-4.999 0-9.067-4.067-9.067-9.067zm-73.767-9.067c4.999 0 9.067 4.067 9.067 9.067v16.557c0 .003-.001.006-.001.01s.001.006.001.01v16.556c0 5-4.067 9.067-9.067 9.067s-9.067-4.067-9.067-9.067v-16.556c0-.003.001-.006.001-.01s-.001-.006-.001-.01v-16.557c0-5 4.067-9.067 9.067-9.067zm-58.767 100.967v-42.201c0-14.134 11.499-25.632 25.632-25.632h9.068v9.066c0 13.271 10.796 24.067 24.067 24.067 13.27 0 24.067-10.796 24.067-24.067v-9.066h34.7v9.066c0 13.271 10.796 24.067 24.067 24.067s24.067-10.796 24.067-24.067v-9.066h34.7v9.066c0 13.271 10.796 24.067 24.067 24.067s24.067-10.796 24.067-24.067v-9.066h34.7v9.066c0 13.271 10.796 24.067 24.067 24.067s24.067-10.796 24.067-24.067v-9.066h9.067c14.134 0 25.633 11.499 25.633 25.632v42.201z"/><path d="m487.941 204.619c-4.142 0-7.5 3.358-7.5 7.5v259.248c0 14.134-11.499 25.633-25.633 25.633h-29.634c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h29.634c22.405 0 40.633-18.228 40.633-40.633v-259.248c0-4.142-3.358-7.5-7.5-7.5z"/><path d="m164.89 180.667h265.067c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-265.067c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z"/><path d="m164.89 230.367h265.067c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-265.067c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z"/><path d="m164.89 280.067h265.067c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-265.067c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z"/><path d="m437.458 371.967c0-4.142-3.358-7.5-7.5-7.5h-173.95c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h173.95c4.142 0 7.5-3.358 7.5-7.5z"/></g></g></svg>
                            </router-link>

                            <a href="" data-toggle="modal" data-target="#exampleModalCenter" @click.prevent="viewAppointment(appointment)">
                              <svg height="20" width="20" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 489.935 489.935" style="enable-background:new 0 0 489.935 489.935;" xml:space="preserve">
                              <g>
                                <g>
                                 <g>
                                   <path d="M486.617,255.067c4.6-6.3,4.4-14.9-0.5-21c-74.1-91.1-154.1-137.3-237.9-137.3c-142.1,0-240.8,132.4-244.9,138
                                      c-4.6,6.3-4.4,14.9,0.5,21c74,91.2,154,137.4,237.8,137.4C383.717,393.167,482.417,260.767,486.617,255.067z M241.617,358.867
                                      c-69.8,0-137.8-38.4-202.4-114c25.3-29.9,105.7-113.8,209-113.8c69.8,0,137.8,38.4,202.4,114
                                      C425.317,274.967,344.917,358.867,241.617,358.867z"/>
                                    <path d="M244.917,157.867c-48,0-87.1,39.1-87.1,87.1s39.1,87.1,87.1,87.1s87.1-39.1,87.1-87.1S292.917,157.867,244.917,157.867z
                                      M244.917,297.767c-29.1,0-52.8-23.7-52.8-52.8s23.7-52.8,52.8-52.8s52.8,23.7,52.8,52.8S274.017,297.767,244.917,297.767z"/>
                                  </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              </svg>
                            </a>
                            <a href="javascript::void(0)" @click.prevent="deleteAppointment(appointment.id)">
                              <svg height="20" viewBox="-40 0 427 427.00131" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m232.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/><path d="m114.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/><path d="m28.398438 127.121094v246.378906c0 14.5625 5.339843 28.238281 14.667968 38.050781 9.285156 9.839844 22.207032 15.425781 35.730469 15.449219h189.203125c13.527344-.023438 26.449219-5.609375 35.730469-15.449219 9.328125-9.8125 14.667969-23.488281 14.667969-38.050781v-246.378906c18.542968-4.921875 30.558593-22.835938 28.078124-41.863282-2.484374-19.023437-18.691406-33.253906-37.878906-33.257812h-51.199218v-12.5c.058593-10.511719-4.097657-20.605469-11.539063-28.03125-7.441406-7.421875-17.550781-11.5546875-28.0625-11.46875h-88.796875c-10.511719-.0859375-20.621094 4.046875-28.0625 11.46875-7.441406 7.425781-11.597656 17.519531-11.539062 28.03125v12.5h-51.199219c-19.1875.003906-35.394531 14.234375-37.878907 33.257812-2.480468 19.027344 9.535157 36.941407 28.078126 41.863282zm239.601562 279.878906h-189.203125c-17.097656 0-30.398437-14.6875-30.398437-33.5v-245.5h250v245.5c0 18.8125-13.300782 33.5-30.398438 33.5zm-158.601562-367.5c-.066407-5.207031 1.980468-10.21875 5.675781-13.894531 3.691406-3.675781 8.714843-5.695313 13.925781-5.605469h88.796875c5.210937-.089844 10.234375 1.929688 13.925781 5.605469 3.695313 3.671875 5.742188 8.6875 5.675782 13.894531v12.5h-128zm-71.199219 32.5h270.398437c9.941406 0 18 8.058594 18 18s-8.058594 18-18 18h-270.398437c-9.941407 0-18-8.058594-18-18s8.058593-18 18-18zm0 0"/><path d="m173.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/></svg>
                            </a>
                        </td>
                      </tr>
                  </tbody>
              </table>
            </div>
            <!--//app-card-body-->
          </div>
          <!--//app-card-->
        </div>
      </div>
      <!--//row-->
    </div>
    <!--//container-fluid-->

  <!-- Modal -->
  <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content" v-if="appointment != null">
        <div class="modal-header">
          <h3 class="modal-title" id="exampleModalLongTitle">Patient Information</h3>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <span><strong>Entry Date:</strong> {{ appointment.custom_today_date }}</span> <br>
              <span><strong>Patient Name:</strong> {{ appointment.patient_name }}</span> <br>
              <span><strong>Gender:</strong> {{ appointment.gender }}</span> <br>
              <span><strong>Age :</strong> {{ appointment.age }}</span> <br>
              
            </div>
            <div class="col-md-6">
              <span><strong>Marital Status:</strong> {{ appointment.marital_status }}</span> <br>
              <span><strong>Occupation:</strong> {{ appointment.occupation }}</span> <br>
            </div>
          </div>
          <div class="row">
              <h3 class="p-2" style="border-bottom: 1px solid #ddd">Address</h3>
              <div class="col-md-6">
                <span><strong>Village:</strong> {{ appointment.village }}</span> <br>
                <span><strong>Road No./House No./Block:</strong> {{ appointment.road_no }}</span> <br>
                <span><strong>Post Office:</strong> {{ appointment.post_office }}</span> <br>
                <span><strong>Police Station:</strong> {{ appointment.upazilla }}</span> <br>
                <span><strong>Districe:</strong> {{ appointment.district }}</span> <br>
              </div>
              <div class="col-md-6">
                <span><strong>Country:</strong> {{ appointment.country }}</span> <br>
                <span><strong>Mobile Number:</strong> {{ appointment.mobile_number }}</span> <br>
                <span><strong>Whatsapp Number:</strong> {{ appointment.whats_app_number }}</span> <br>
                <span><strong>Email:</strong> {{ appointment.e_mail }}</span> <br>
              </div>
          </div>
          <div class="row">
            <h3 class="p-2" style="border-bottom: 1px solid #ddd">Case Taking  Form</h3>
            <ol class="col-md-12 ml-4" style="display: grid;grid-row-gap: .45rem">
              <li>
                <strong class="col-md-6">রোগের বিবরণ /Description of the disease:</strong> {{ appointment.disease }}</li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">কত দিন হয়েছে?/How many days has it been?</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.occurred">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">কারণ কি? /What is the reason?</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.main_problem">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">চিকিৎসা নিয়েছেন? /Received treatment?</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.treatment">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">রোগের পরিবর্তন/Changes in disease:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.changes_in_disease">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">শারীরিক আকৃতি/Physical shape:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.physical_shape">
                </div>
              </li>
              
              <li>
                <div class="col-md-12 row align-items-center">
                  <strong class="col-md-6">অতীতের রোগ/Past diseases:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.past_disease">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">জিহ্বা/Tongue:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.tongu">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">পিপাসা/Thirst:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.thirts">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">ক্ষুধা/Hunger:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.hunger">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">পেট/Stomach:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.stomach">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">খাবার খুব পছন্দ/Very fond of food:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.favorite_food">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">খাবার খুব অপছন্দ/Dislike food very much:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.hated_food">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">ঘুম/Sleep:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.sleep">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">ভয়/ Fear:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.fear">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">হার্ট/Heart:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.heart">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">কাতরতা/Bitterness:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.bitterness">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">স্মরণশক্তি/ Memory:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.memory">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">মেজাজ মর্জি/ Temperament:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.temperment">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">মানসিক/Mental:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.mental">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">ঘাম/Sweat:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.sweat">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">স্বপ্ন/Dream:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.dream">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">পায়খানা/Closet:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.closet">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">প্রসাব/Urine:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.urination">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">মাসিকের অবস্থা /Menstrual condition:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.menstruation">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">যৌন সমস্যা/Sexual problems:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.sexually">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">বংশগত রোগ /Hereditary diseases:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.hereditary">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">গোসল বা পরিচ্ছন্নতা/Bathing or cleaning:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.bathing_cleaning">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">শরীরের ব্যথা বেদনা/Body aches and pains:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.pains">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">শরীরে জ্বালা পোড়া/Burning in the body:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.burnings">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">অপারেশন/ Operation:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.operation">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">পার্শ্ব পরিবর্তন/Change of side:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.side_changes">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">ডায়েবেটিস/Diabetes:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.diabetes">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">উচ্চ রক্তচাপ/ Hypertension:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.hypertension">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">কোলেস্টেরল /Cholesterol:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.cholesterol">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">চর্ম রোগ/Skin diseases:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.skin_diseases">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">শ্বাসযন্ত্র/Respiratory system:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.respiratory">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">ক্যান্সার /Cancer:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.cancer">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">এলার্জি/Allergy:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.allergy">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">কিডনি রোগ /Kidney disease:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.kidney">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">টাইফয়েড/Typhoid:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.typhoid">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">যক্ষ্মা/Tuberculosis:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.tuberculosis">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">ম্যালেরিয়া/Malaria:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.malaria">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">অদ্ভুত লক্ষন/Peculiar symptoms:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.peculiar_symptoms">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">নেশাগ্রস্ত/Intoxicated:</strong>
                  <input type="text" class="form-control border-2" style="width: 41%" v-model="appointment.intoxicated">
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">অন্যান্য রোগ/Other diseases:</strong>
                  <textarea type="text" class="form-control border-2" style="width: 41%; height: 60px" v-model="appointment.others_disease" v-text="appointment.others_disease"></textarea>
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">টেস্ট রিপোর্ট/Test report:</strong>
                  <textarea type="text" class="form-control border-2" style="width: 41%; height: 60px" v-model="appointment.test_report" v-text="appointment.test_report"></textarea>
                </div>
              </li>
              <li>
                <div class="col-md-12 row align-items-center">
                <strong class="col-md-6">ডাক্তারের  মন্তব্য/Doctor's remarks:</strong>
                  <textarea type="text" class="form-control border-2" style="width: 41%; height: 60px" v-model="appointment.remarks" v-text="appointment.remarks"></textarea>
                </div>
              </li>

            </ol>

          </div>
          <h3 class="py-2" style="border-bottom: 1px solid #ddd">Payment & Treatment</h3>
          <div class="col-md-6">
            <span><strong>Treatment:</strong> {{ appointment.payment_type }}</span> <br>
            <span><strong>Appointment date:</strong> {{ appointment.custom_appointment_date }}</span> <br>
            <span><strong>Time:</strong> {{ appointment.time }}</span> <br>
            <span><strong>Treated:</strong> {{ appointment.treated }}</span> <br>
            <span><strong>Payment  বিকাশ নাম্বার/ Transaction ID:</strong> {{ appointment.transaction_id }}</span> <br>
          </div>
          <div class="row">
            <h3 class="p-2" style="border-bottom: 1px solid #ddd">Prescription</h3>
            <div class="col-md-12">
              <table class="table table-sm table-bordered">
                <thead class="text-center">
                  <th>Medicine</th>
                  <th>Description</th>
                </thead>
                <tbody class="text-center">
                  <tr v-for="(medicine, prescriptionInd) in appointment.prescriptions" :key="prescriptionInd">
                    <td>{{ medicine.medicine_name }}</td>
                    <td>{{ medicine.description }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
           <button class="btn btn-sm btn-info" @click.prevent="updateAppointment(appointment.id)" >
              Save Form
            </button>
           <router-link target="_blank" class="btn btn-sm btn-primary" :to="{ name: 'SingleAppointment', params: { id: appointment.id } }">
              Write prescription
            </router-link>
        </div>
      </div>
    </div>
  </div>

  </div>
</template>
<script>
import appointment from "@/store/appointment";

export default {
  name: 'Appointments',
  data: ()=> ({
    isLoading: false,
    appointments: [],
    appointment: null,
    searchBy: ''
  }),
  async created(){
    await this.getAppointments();
  },
  methods: {
    viewAppointment: function(appointment) {
      this.appointment = appointment;
      
    },
    
    getAppointments: async function() {
      this.isLoading = true;
      await this.$store.dispatch('appointment/getAppointments', {nameOrMobile: this.searchBy});
      this.appointments = await this.$store.getters['appointment/appointments'];
      this.isLoading = false;
    },

    deleteAppointment: async function(id) {
      if(confirm("Are you sure ?")){
        await axios.post('delete_appointment', {appointmentId: id}, {
          headers: {
            Authorization: this.$store.getters['auth/jwt'],
            "Content-Type": "application/json",
          }
        })
        .then(res => {
          this.getAppointments();
        })
        .catch(error => {
        })
      }
    },

    updateAppointment: async function(id) {
      let success = false
      await axios.post("update_appointment/"+id, {appointment: this.appointment}, {
        headers: {
          Authorization: this.$store.getters['auth/jwt'],
          "Content-Type": "application/json",
        }
      }).then(res => {
        alert('Appointment Updated Successfully');
        success = true
      }).catch(error => console.log(error.message));
      return success;
    }
  },
}
</script>

<style scoped>
  .form-control{
    border-color: #6c8ed1 !important;
  }
</style>
